<template>
  <v-app class="app-main">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import './assets/scss/main.scss';

.app-main {
  $this: 'app-main';
  background-color: $color-athens-gray;
}
</style>
